import { useState } from "react";

import Modal from "../Modal";

type EditButtonProps = {
  form: (closeModal: (evt?: React.MouseEvent) => void) => React.ReactNode;
};

export default function EditButton(props: EditButtonProps) {
  const [editing, setEditing] = useState(false);

  const handleClick = (evt: React.MouseEvent) => {
    evt.preventDefault();
    setEditing(true);
  };

  const closeModal = (evt?: React.MouseEvent) => {
    if (evt) {
      evt.preventDefault();
      evt.stopPropagation();
    }
    setEditing(false);
  };

  return (
    <div className="edit-button">
      {editing && <Modal onClose={closeModal}>{props.form(closeModal)}</Modal>}
      <button onClick={handleClick}>
        <i className="material-icons">edit</i>
      </button>
    </div>
  );
}
